import TextIcon from 'components/TextIcon/styled';

export default TextIcon;
